import { companyMoreOptions } from "modules/companies/company/company.constant";

export const productMobileMoreOptions = [
  { val: "requestResearch", text: "Request Research" },
  { val: "note", text: "Note" },
  { val: "follow", text: "Follow" },
  { val: "newProject", text: "New project" },
  ...companyMoreOptions,
];
